export enum TipoConsulta {
  AVULSA,
  COMPOSTA,
  COMBINADA,
  CREDITO,
  EXPERIMENTAL,
}
